export default __webpack_public_path__ + "static/media/individual-icon.7f5e5545.svg";